import { Modal } from "react-bootstrap";
import GoogleAutoComplete from "../autocomplete/google_autocomplete.js";
import DanishAutoComplete from "../autocomplete/danish_autocomplete.js";
import { config } from "../../Constants.js";
import { LoadScript } from "@react-google-maps/api";
import { FormattedMessage } from "react-intl";

const AddressModal = ({
  show,
  handleClose,
  saveAddress,
  onPlaceSelected,
  isDanish,
  address,
  setAddress,
}) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <div className="modal-content p-2">
        <div
          className="modal-header border-0 d-flex justify-content-end"
          style={{ padding: "13px" }}
        >
          <span
            className="close-text"
            style={{ cursor: "pointer" }}
            onClick={handleClose}
            role="button"
          >
            <FormattedMessage id="Close" /> &#10006;
          </span>
        </div>
        <div className="pageD align-items-center justify-content-center text-center">
          <div>
            <h6>
              <FormattedMessage id="Address" />
            </h6>
            {!isDanish && (
              <LoadScript
                googleMapsApiKey={config.url.GOOGLE_API_KEY}
                libraries={["places"]}
              >
                <GoogleAutoComplete
                  onPlaceSelected={onPlaceSelected}
                  inputValue={address}
                  setInputValue={setAddress}
                  isProfile={true}
                />
              </LoadScript>
            )}
            {isDanish && (
              <DanishAutoComplete
                onPlaceSelected={onPlaceSelected}
                inputValue={address}
                setInputValue={setAddress}
                isProfile={true}
              />
            )}
            <div
              className="btn btn-dark-blue row-80"
              id="editAddress"
              onClick={() => saveAddress()}
            >
              <FormattedMessage id="Save" />{" "}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddressModal;
